/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { ChangeEvent, useCallback, useEffect, useState } from 'react'
import { delete_employee_attendance, get_all_employee_attendance, get_all_filtered_attendance, update_employee_attendance } from '../../../../app/pages/Employees/attendance/api/attendanceApi';
import { useMutation, useQuery } from 'react-query';
import { get_all_attendance_types } from '../../../../app/pages/Settings/attendance-types/api/attendanceTypeApi';
import { toast } from 'react-toastify';
import { KTIcon, KTSVG } from '../../../helpers';
import { useNavigate } from 'react-router-dom';
import { formatDateWithTime } from './../../../../app/helper-functions/DateFunction';
import { Attendance} from '../../../../app/modules/accounts/components/settings/SettingsModel';
type Props = {
  className: string;
  employee_attendance_by_id:Attendance[]
};

const TablesWidget12: React.FC<Props> = ({className,employee_attendance_by_id}) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [visibleData, setVisibleData] = useState<Attendance[]>([]);
    const [attendanceList, setAttendanceList] = useState<Attendance[]>([]);
    const [selectedItemsPerPage, setSelectedItemsPerPage] = useState(5);
    const [sortBy, setSortBy] = useState<{ key: string, ascending: boolean } | null>(null);
    const [selectedFromDate, setSelectedFromDate] = useState<string>("");
    const [selectedToDate, setSelectedToDate] = useState<string>("");
    const authData = JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}');
    const [originalAttendanceList, setOriginalAttendanceList] = useState<Attendance[]>([]); // To store the original list
    const navigate = useNavigate();

    useEffect(() => {
        const today = new Date().toISOString().slice(0, 10); // Get today's date in 'YYYY-MM-DD' format
    
        if (Array.isArray(employee_attendance_by_id) && employee_attendance_by_id.length > 0) {
    
            // Set today's date as default for 'From Date' and 'To Date'
            setSelectedFromDate(today);
            setSelectedToDate(today);
    
            // Filter attendance records to show only today's attendance
            const filteredAttendance = employee_attendance_by_id.filter((attendance: any) => {
                const attendanceDate = attendance.attendance_datetime?.slice(0, 10);
                return attendanceDate === today;
            });
    
            // Set the filtered attendance list
            setAttendanceList(filteredAttendance);
            setOriginalAttendanceList(filteredAttendance);
        } else {
            setAttendanceList([]); // No data case
        }
    }, [employee_attendance_by_id]);    
      // console.log("attendanceList",attendanceList)
      // console.log("originalAttendanceList",originalAttendanceList)
    const itemsPerPageOptions = [10, 20, 30, 50, 100]; // Step 2: Options for items per page
    const totalItems = attendanceList.length;
    const totalPages = Math.ceil(totalItems / selectedItemsPerPage); // Update total pages based on selected items per page
    useEffect(() => {
        if (attendanceList.length > 0) {
            let sortedData = [...attendanceList];
            if (sortBy) {
                sortedData.sort((a, b) => {
                    const aValue = (a[sortBy.key] || '') as string;
                    const bValue = (b[sortBy.key] || '') as string;
                    return sortBy.ascending ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
                });
            }
            setVisibleData(
                sortedData.slice(
                    (currentPage - 1) * selectedItemsPerPage, // Update slice based on selected items per page
                    currentPage * selectedItemsPerPage
                )
            );
        }
    }, [attendanceList, currentPage, selectedItemsPerPage, sortBy]);
    const handleSort = (key: string) => {
        if (sortBy && sortBy.key === key) {
            setSortBy({ key, ascending: !sortBy.ascending });
        } else {
            setSortBy({ key, ascending: true });
        }
    };
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>My Today's Attendance
          ({authData?.user?.full_name})</span>
        </h3>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3'>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table align-middle gs-0 gy-4'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bold text-muted'>
                <th className='min-w-150px'>Attendance Type <span onClick={() => handleSort('attendance_type_name')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th>
                <th className='min-w-120px'>Time <span onClick={() => handleSort('attendance_datetime')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th>
                <th className='min-w-120px'>Shift <span onClick={() => handleSort('shift_name')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th>
                <th className='min-w-120px'>Updated By <span onClick={() => handleSort('updated_by_name')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>
              {Array.isArray(attendanceList) && attendanceList.length > 0 ? (
                visibleData.map((attendance: any) => (
                  <tr key={attendance.id}>
                    <td>
                      <div className='d-flex align-items-center'>
                        <div className='d-flex justify-content-start flex-column'>
                          <h3 className='text-dark fw-bold  fs-6'>
                            {attendance.attendance_type_name}
                          </h3>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className='d-flex align-items-center'>
                        <div className='d-flex justify-content-start'>
                          {formatDateWithTime(attendance.attendance_datetime)}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className='d-flex align-items-center'>
                        <div className='d-flex justify-content-start'>
                          {attendance.shift_name}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className='d-flex align-items-center'>
                        <div className='d-flex justify-content-start'>
                          {attendance.updated_by_name}
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td>No My Attendance Available.</td>
                </tr>
              )}
            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {
        totalItems>=6&&(
          <div className='card-footer d-flex justify-content-between py-4'>
          <div className='align-items-center row'>
            <div className='d-flex'>
              <div className='col-md-9 mt-5'><strong>Results Per Page:</strong></div>
              <select
                className='form-select-md'
                value={selectedItemsPerPage}
                onChange={(e) => setSelectedItemsPerPage(Number(e.target.value))}
              >
                {itemsPerPageOptions.map(option => (
                  <option key={option} value={option} className='p-3 '>{option}</option>
                ))}
              </select>
            </div>
          </div>
          <div className='d-flex justify-content-end'>
            {currentPage === 1 ? (
              <button
                className='btn btn-light'
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
              >
                Previous
              </button>
            ) : (
              <button
                className='btn btn-primary'
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
              >
                Previous
              </button>
            )}
            <button
              className='btn btn-primary ms-2'
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
        )
      }
      {/* begin::Body */}
    </div>
  )
}

export {TablesWidget12}
